module.exports = __webpack_public_path__ + "img/watatsuki no yorihime_lw.c5afae56.png";